import {
  ArticleList,
} from "@babackapp/customer-ui/components/article";
import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
  SectionHeader,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { WidgetErrorBoundary } from "../widget-error-boundary";
import { EnterIcon } from "@radix-ui/react-icons";
import { ThumbsUpIcon } from "lucide-react";
import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useLineItemConfirmation } from "../../hooks/use-line-item-confirmation";
import { LineItemRow } from "./line-item-row";

export function LineItemConfirmation() {
  const t = useCustomText();
  const { remainingItems, orderId, shopId } = useLineItemConfirmation();

  return (
    <WidgetPage>
      <motion.span
        initial={{ opacity: 0, scale: 0.9, y: 5, rotate: 10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
        exit={{
          opacity: 0,
          y: 20,
          transition: { duration: 0.25, ease: "easeIn" },
        }}
        transition={{ delay: 0.2, type: "spring" }}
        style={{ transformOrigin: "top left" }}
        className="mx-auto"
      >
        <ThumbsUpIcon className="text-success-foreground size-10" />
      </motion.span>

      <Header>
        <HeaderTitle>{t("lineItemConfirmation.title")}</HeaderTitle>
        <HeaderDescription>
          {t("lineItemConfirmation.description")}
        </HeaderDescription>
      </Header>

      {/* Confirm button always above the add-items section */}
      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer
          layoutId="line-item-confirm-button"
          disableVariants={{ enter: true, exit: true }}
        >
          <Link to="../../../summary" relative="path">
            <Button>
              <EnterIcon />
              {t("common.finalise")}
            </Button>
          </Link>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>

      {remainingItems.length > 0 && (
        <div className="flex flex-col gap-2 w-full">
          <SectionHeader>{t("common.addAnotherItem")}</SectionHeader>
          <WidgetErrorBoundary>
            <ArticleList className="cursor-pointer">
              {remainingItems.map((lineItem) => (
                <LineItemRow
                  key={lineItem.line_item_id}
                  lineItem={lineItem}
                  orderId={orderId}
                  shopId={shopId}
                />
              ))}
            </ArticleList>
          </WidgetErrorBoundary>
        </div>
      )}
    </WidgetPage>
  );
}
